import styles from './tab-products.module.css'

export const getViewClasses = (editing: boolean) => {
  return `${styles.view} ${editing ? styles['view-editing'] : ''}`
}

export const getViewCardsClasses = (editing: boolean) => {
  return `${styles['view-card']} ${editing ? styles['view-card-editing'] : ''}`
}

export const getFormCardsClasses = (editing: boolean) => {
  return `${styles['view-form']} ${editing ? styles['view-form-editing'] : ''}`
}

export const getFormClasses = (editing: boolean) => {
  return `${styles.form} ${!editing ? styles.hidden : ''}`
}
